export const PERMISOS = {
  panel: { ver: 'panel:ver' },
  inventario: { ver: 'inventario:ver' },
  movimientos: { ver: 'movimientos:ver' },
  pedidos: { ver: 'pedidos:ver' },
  recepciones: { ver: 'recepciones:ver' },
  surtido: { ver: 'surtido:ver' },
  packing: { ver: 'packing:ver' },
  embarques: { ver: 'embarques:ver' },
  rutas: { ver: 'rutas:ver' },
  transporte: { ver: 'transporte:ver' },
  analiticas: { ver: 'analiticas:ver' },
  almacenes: { ver: 'almacenes:ver' },
  ubicaciones: { ver: 'ubicaciones:ver' },
  productos: { ver: 'productos:ver' },
  clientes: { ver: 'clientes:ver' },
  proveedores: { ver: 'proveedores:ver' },
  transportistas: { ver: 'transportistas:ver' },
  vehiculos: { ver: 'vehiculos:ver' },
  empresas: { ver: 'empresas:ver' },
  usuarios: { ver: 'usuarios:ver' },
  perfiles: { ver: 'perfiles:ver' },
  roles: { ver: 'roles:ver' },
  licencias: { ver: 'licencias:ver' },
  configuracion: { ver: 'configuracion:ver' },
  reportes: { ver: 'reportes:ver' },
} as const
